// Routes match the old Wix site's URLs so existing links & search results keep working
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/who-is-derma",
  DERMA_PRODUCTS: "/products-derma",
  STOCKIST: "/become-a-stockist",
  CLINICS: "/clinic-booking",
  //"Training Courses" - lists the course pages (on Wix a members-only page at /blank, which redirects here)
  TRAINING: "/training-courses",
  //The policies were on the Lovable preview site (int-derma.lovable.app/policies/...)
  POLICY: "/policies/:policySlug",
  //The whole shop, and /category/acne... (see SHOP_CATEGORIES)
  SHOP: "/shop",
  CATEGORY: "/category/:categorySlug",
  PRODUCT: "/product-page/:productSlug",
  CART: "/cart-page",
  ORDER_RESULT: "/order/:result",
  //One page per course: /coolsculpt, /laserlipocourse... (see data/courses.js)
  //Customer accounts (needed to see & buy Derma 2.0® products)
  ACCOUNT: "/account",
  LOGIN: "/account/login",
  REGISTER: "/account/register",
  FORGOT_PASSWORD: "/account/forgot-password",
  RESET_PASSWORD: "/account/reset-password",
  COURSE: "/:courseSlug",
};
//"Contact Us" in the menu scrolls to the home page's contact form
export const CONTACT_ANCHOR = "/#contact";

//The login / register pages, coming back to `returnTo` (e.g. a Derma product page) afterwards
export const getLoginRoute = (returnTo, register=false) => (
  `${register ? PAGE_ROUTES.REGISTER : PAGE_ROUTES.LOGIN}${returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`
);

export const getProductRoute = (slug) => (
  PAGE_ROUTES.PRODUCT.replace(":productSlug", slug)
);

export const getCategoryRoute = (slug) => (
  (slug === ALL_PRODUCTS) ? PAGE_ROUTES.SHOP : PAGE_ROUTES.CATEGORY.replace(":categorySlug", slug)
);

export const getCourseRoute = (slug) => (
  PAGE_ROUTES.COURSE.replace(":courseSlug", slug)
);

export const getPolicyRoute = (slug) => (
  PAGE_ROUTES.POLICY.replace(":policySlug", slug)
);

// The Wix store categories (all shown in the shop's "Browse by" list). A product's Category field lists the ones it's in
// ("Acne, Serums"). Names are the Wix ones in title case ("Age Prevention" was "AGE PREFENTION"); slugs are Wix's.
export const ALL_PRODUCTS = "all-products";
export const SHOP_CATEGORIES = [
  { name: "All Products", slug: ALL_PRODUCTS },
  { name: "Acne", slug: "acne" },
  { name: "Age Prevention", slug: "age-prefention" },
  { name: "Aging", slug: "aging" },
  { name: "Alopecia", slug: "alopecia" },
  { name: "Bio-Revitalizing", slug: "bio-revitalizing" },
  { name: "Cellulite", slug: "celu" },
  { name: "Chemical Peels", slug: "chemical-peels" },
  { name: "Cleansers", slug: "cleansers" },
  { name: "Cosmeceuticals", slug: "cosmeceuticals" },
  { name: "Dark Circles & Bags", slug: "dark-circles-bags" },
  { name: "Derma Products", slug: "derma-products" },
  { name: "Enzyme Exfoliant", slug: "enzyme-exfoliant" },
  { name: "Exfoliant", slug: "exfoliant" },
  { name: "Exosome", slug: "exosome" },
  { name: "Eye", slug: "eye" },
  { name: "Firming", slug: "firming" },
  { name: "Home Care", slug: "home-care" },
  { name: "Hydrating", slug: "hydrating-1" },
  { name: "Hyperpigmentation", slug: "hyperpigmentation" },
  { name: "Laser Equipment", slug: "laser-equipment" },
  { name: "Laser Training", slug: "laser-college-training" },
  { name: "Lipo", slug: "lipo" },
  { name: "Localized Fat", slug: "localized-fat" },
  { name: "Masks", slug: "masks" },
  { name: "Melasma", slug: "melasma" },
  { name: "Microneedling", slug: "microneedling" },
  { name: "Moisturisers", slug: "moisturisers" },
  { name: "Neck", slug: "neck" },
  { name: "Numbing Cream", slug: "numbing-cream" },
  { name: "Pigmentation", slug: "pigmentation" },
  { name: "Post Treatment", slug: "post-treatment" },
  { name: "Post-Inflammatory Pigmentation", slug: "post-inflammatory-pigmentation" },
  { name: "Pre Treatment", slug: "pre-treatment" },
  { name: "Product Training", slug: "product-training" },
  { name: "Purifying", slug: "pyrifying" },
  { name: "Rejuvelift", slug: "rejuvelift" },
  { name: "Scars", slug: "scars" },
  { name: "Serums", slug: "serums" },
  { name: "Skin Barrier", slug: "skin-barrier" },
  { name: "Skin HITT", slug: "skin-hitt" },
  { name: "Stretch Marks & Scars", slug: "stretch-marks-scars" },
  { name: "Teen Skin", slug: "teen-skin" },
  { name: "Training Courses", slug: "training-courses" },
  { name: "Whitening", slug: "whitening" },
];
//The "Shop" menu, in the Wix order (after "Derma Products")
export const SHOP_MENU_CATEGORIES = [
  "acne",
  "aging",
  "alopecia",
  "bio-revitalizing",
  "celu",
  "chemical-peels",
  "dark-circles-bags",
  "exfoliant",
  "eye",
  "cosmeceuticals",
  "firming",
  "home-care",
  "hydrating-1",
  "hyperpigmentation",
  "laser-equipment",
  "lipo",
  "localized-fat",
  "post-treatment",
  "pre-treatment",
  "product-training",
  "pyrifying",
  "rejuvelift",
  "stretch-marks-scars",
  "whitening",
];
export const DERMA_PRODUCTS_CATEGORY = "Derma Products";

//Courses are booked, not couriered: a cart with only these needs no delivery address
export const COURSE_CATEGORIES = ["Training Courses", "Laser Training", "Product Training"];

export const CONTACT_DETAILS = {
  EMAIL: "hello@int-aesthetics.co.za",
  PHONE: "063 479 3969",
  PHONE_LINK: "tel:+27634793969",
  CITY: "Pretoria",
  TAPX: "https://www.tap-x.com/",
};

//The catalogue PDFs in the "About Derma 2.0" menu live in blob storage (media/) - see SETUP.md
// eslint-disable-next-line no-undef
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
export const CATALOGUES = {
  REJUVELIFT: { label: "Rejuvelift Catalogue", href: `${MEDIA_URL}/rejuvelift-catalogue.pdf` },
  DERMA: { label: "Derma 2.0® Catalogue", href: `${MEDIA_URL}/derma-2-catalogue.pdf` },
  LASER: { label: "Laser Catalogue", href: `${MEDIA_URL}/laser-catalogue.pdf` },
};

//The Derma 1 Skin & Laser Clinics - the first five can be booked on the Clinic Bookings form
export const CLINICS = [
  { name: "Pretoria Silverlakes", phone: "084 362 1926", bookable: true },
  { name: "Capetown Blouberg", phone: "082 774 5536", bookable: true },
  { name: "Benoni", phone: "+27 (82) 562-8594", bookable: true },
  { name: "Swellendam", phone: "(082) 878-1688", bookable: true },
  { name: "Kimberley", phone: "(082) 456-2179", bookable: true },
  { name: "Advanced Aesthetic Clinic, Hartebeespoortdam", phone: "+27 63 739 2112" },
  { name: "Neo Aesthetics Clinic, Durbanville", phone: "+27 60 729 1218" },
  { name: "Meraki Health and Beauty Clinic, Kempton Park", phone: "+27 (82) 874-1653" },
  { name: "Evolve Skin Hair and Laser, Century City", phone: "064 657 9940" },
  { name: "Xclusively You Aesthetics, Benoni", phone: "071 424 1052" },
  { name: "Advanced Longevity Clinic, Durbanville", phone: "+27 (63) 479-3969" },
  { name: "Glam-co Fat Freeze, Ermelo", phone: "+27 72 888 3949" },
];

//Tel links for the clinics' numbers
export const getTelLink = (phone) => {
  const digits = phone.replace(/[^0-9+]/g, "");
  return `tel:${digits.startsWith("0") ? `+27${digits.slice(1)}` : digits}`;
};

//Must match ContactForms in Model/Order.cs
export const CONTACT_FORMS = {
  CONTACT: "contact",
  STOCKIST: "stockist",
  BOOKING: "booking",
};
export const STOCKIST_INTERESTS = ["Becoming a Stockist", "Training Sessions"];

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
  CUSTOMER_LOGIN: "ls_6",
  CUSTOMER_REGISTER: "ls_7",
  CUSTOMER_FORGOT: "ls_8",
  CUSTOMER_RESET: "ls_9",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};


export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
];
